interface IGetDatepickerSlotPropsProps {
  id?: string;
  isError?: boolean;
  errorText?: string;
  placeholder?: string;
  name?: string;
  dataT1?: string;
  disabled?: boolean;
  isMobile?: boolean;
}

const getDatepickerSlotProps = ({
  id,
  isError,
  errorText,
  placeholder,
  name,
  dataT1,
  disabled,
  isMobile,
}: IGetDatepickerSlotPropsProps) => {
  return {
    textField: {
      id,
      fullWidth: true,
      error: isError,
      helperText: isError ? errorText : "",
      placeholder,
      name,
      inputProps: { "data-t1": dataT1 },
      FormHelperTextProps: {
        sx: {
          fontWeight: `600 !important`,
          marginLeft: `0 !important`,
          marginTop: `10px !important`,
          fontSize: `0.75rem !important`,
        },
      },
      sx: {
        "& .MuiInputBase-root.Mui-focused": {
          outline: "1px solid #1879ce",
          outlineOffset: "none",
          boxShadow: "none",
        },
        "& .MuiInputBase-root.Mui-disabled": {
          backgroundColor: "#fff",
          color: "#93B5B5",
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "2rem",
          backgroundColor: "#fff",
          transition: "none",
          padding: "9px 25px",

          "& fieldset": {
            borderColor: disabled ? "#93B5B5" : "#577D7D",
          },

          "&:hover fieldset": {
            borderColor: "#577D7D",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#577D7D",
            borderWidth: "1px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            transition: "none",
          },
          "& .MuiOutlinedInput-notchedOutline legend": {
            width: 0,
          },
        },

        "& input": {
          padding: isMobile ? "6.5px 0" : 0,
          fontSize: "13px",
          lineHeight: "150%",
        },
        "& input::placeholder": {
          color: "#577D7D !important",
          opacity: 1,
        },
        "& .MuiInputAdornment-root svg path": {
          fill: disabled ? "#93B5B5" : "#102B3F",
        },
      },
    },

    toolbar: {
      toolbarFormat: "ddd, D MMM",
      sx: {
        "& .MuiTypography-root": {
          fontSize: "13px",
          textTransform: "none",
          lineHeight: "150%",
          color: "#577D7D",
          letterSpacing: "normal",
        },
        "& .MuiDatePickerToolbar-title": {
          fontWeight: 800,
          fontSize: "2.125rem",
          lineHeight: "120%",
          color: "#102B3F",
          marginTop: "4px",
          textTransform: "capitalize",
        },
      },
    },
    actionBar: {
      sx: {
        justifyContent: "space-between",
        "& *:focus": {
          outline: "none",
        },
      },
    },
    popper: {
      disablePortal: true,
      sx: {
        "& .MuiPaper-root": {
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          padding: 0,
        },
        "& *:focus": {
          outline: "none",
        },
      },
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
      ],
    },

    dialog: {
      sx: {
        "& .MuiPaper-root": {
          borderRadius: "16px",
        },
        "& .MuiPickersDay-root:focus": {
          outline: "none",
        },
      },
    },

    calendarHeader: {
      sx: {
        "& .MuiPickersCalendarHeader-label": {
          fontWeight: 400,
          fontSize: "17px",
          lineHeight: "150%",
        },
        "& .MuiIconButton-root": {
          color: "#102B3F",
        },
      },
    },

    day: {
      disableRipple: true,
      sx: {
        fontSize: "13px",
        color: "#102B3F",
        lineHeight: "150%",

        "&.MuiPickersDay-root": {
          borderRadius: "50%",
        },

        "&:hover": {
          backgroundColor: "rgba(0, 161, 237, 0.1)",
        },

        "&.Mui-selected": {
          backgroundColor: "#00A1ED !important",
          color: "#fff",
        },

        "&.MuiPickersDay-today:not(.Mui-selected)": {
          border: "1px solid #102B3F",
        },

        "&.Mui-disabled": {
          color: "#93B5B5",
        },

        "&.Mui-focusVisible": {
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
        "&:active": {
          backgroundColor: "#00A1ED",
        },
      },
    },
    openPickerButton: {
      disableRipple: true,
      sx: {
        transition: "background-color 0.3s ease",
        "&:focus": {
          outline: "none",
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
        "&:hover": {
          backgroundColor: "rgba(0, 161, 237, 0.1)",
        },
        "&:active": {
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
      },
    },
    previousIconButton: {
      disableRipple: true,
      sx: {
        transition: "background-color 0.3s ease",
        "&:focus": {
          outline: "none",
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
        "&:hover": {
          backgroundColor: "rgba(0, 161, 237, 0.1)",
        },
        "&:active": {
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
      },
    },

    nextIconButton: {
      disableRipple: true,
      sx: {
        transition: "background-color 0.3s ease",
        "&:focus": {
          outline: "none",
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
        "&:hover": {
          backgroundColor: "rgba(0, 161, 237, 0.1)",
        },
        "&:active": {
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
      },
    },

    switchViewButton: {
      disableRipple: true,
      sx: {
        transition: "background-color 0.3s ease",
        "&:focus": {
          outline: "none",
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
        "&:hover": {
          backgroundColor: "rgba(0, 161, 237, 0.1)",
        },
        "&:active": {
          backgroundColor: "rgba(0, 161, 237, 0.2)",
        },
      },
    },
  };
};

export default getDatepickerSlotProps;
